// apps/client/src/components/errors/Error500.tsx
import React from 'react';
import { ErrorTemplate, ErrorButtons } from './ErrorTemplate';

export const Error500: React.FC = () => {
  return (
    <ErrorTemplate
      title="500"
      heading="Internal Server Error"
      message="Something went wrong on our end. We're working to fix this issue. Please try again in a few moments."
      buttons={[ErrorButtons.HOME, ErrorButtons.REFRESH]}
    />
  );
};

export default Error500;
